const envMapping: Record<string, string[]> = {
  usw: ["usw", "woo", "shop"],
};

export const getDomainEnvironment = (envs: string[]) => {
  const domain = window.location.hostname;
  const env = envs?.find((env) => {
    // hard code hack for woo, treat as usw
    if (envMapping[env]) {
      return envMapping[env].some((e) => domain.includes(e));
    }
    return domain.includes(env);
  });
  return env || envs?.[0];
};
